export default {
  mealMap: {
    eat_in: "內",
    to_go: "自",
    delivery: "送"
  },
  mealTypeIcon: {
    eat_in: "icon_inside",
    to_go: "icon_self",
    delivery: "icon_delivery"
  },
  payTypeIcon: {
    cash: "icon_cash",
    qrpay_credit: "icon_creditcard",
    qrpay_google: "icon_googlepay",
    qrpay_line: "icon_linepay",
    qrpay_apple: "icon_applepay",
    qrpay_easywallet: "icon_easywallet",
    qrpay_taiwanpay: "icon_taiwanpay",
    qrpay_jko: "icon_jkopay",
    qrpay_icashpay: "icon_icash",
    qrpay_pxpay: "icon_pxpay",
    qrpay_pxpayplus: "icon_pxpay",
    qrpay_pluspay: "icon_pluspay",
    apple: "icon_applepay",
    samsung: "icon_creditcard",
    multiple: "icon_creditcard",
    line: "icon_linepay",
    google: "icon_googlepay",
    easywallet: "icon_easywallet",
    taiwanpay: "icon_taiwanpay",
    jkopay: "icon_jkopay",
    pxpay: "icon_pxpay",
    pxpayplus: "icon_pxpay",
    icashpay: "icon_icash",
    pluspay: "icon_pluspay"
  },
  payMap: {
    cash: "現金",
    qrpay_credit: "信用卡",
    qrpay_google: "Google Pay",
    qrpay_line: "LINE Pay",
    qrpay_apple: "Apple Pay",
    apple: "Apple Pay",
    samsung: "Samsung Pay",
    multiple: "行動支付",
    line: "LINE Pay",
    google: "Google Pay",
    taiwanpay: "台灣Pay",
    jkopay: "街口Pay",
    easywallet: "悠遊付",
    pxpay: "全支付",
    pxpayplus: "全支付",
    icashpay: "icash Pay",
    pluspay: "全盈支付"
  },
  label: {
    new: "商家正在確認訂單",
    accepted: "店家已接收訂單",
    done: "餐點完成",
    rejected: "訂單已取消",
    cancelled: "訂單已取消",
    lala_assigning_driver: "媒合司機中",
    lala_on_going: "司機取餐中",
    lala_picked_up: "司機送餐中",
    lala_completed: "成功送達",
    lala_rejected: "司機取消物流"
  },
  sLabel: {
    new: "已下單",
    accepted: "已接單",
    done: "已完成",
    rejected: "已取消",
    cancelled: "已取消",
    lala_assigning_driver: "媒合司機",
    lala_on_going: "司機取餐",
    lala_picked_up: "司機送餐",
    lala_completed: "成功送達",
    lala_rejected: "物流取消"
  }
}